<section class="title-container">
    <h2 class="title">
        {{ 'Reports.SuccessRate.Title' | translate }}
    </h2>
    <hr class="separation-line" />
</section>

<section class="filters-container">
    <fieldset class="customers">
        <label class="label">
            {{'Reports.Filters.CustomerNumbers' | translate}}
        </label>
        <custom-multi-select [options]="customers$ | async" [searchEnabled]="userAssignedCustomersCount > 3"
            [(selectedKeys)]="selectedCustomers" [displayDetailedSelection]="true" [disabled]="userAssignedCustomersCount <= 1">
        </custom-multi-select>
    </fieldset>
    <fieldset>
        <label for="period" class="label">
            {{'Reports.Filters.Period' | translate}}
        </label>
        <custom-select name="period" [options]="periodOptions" [(selectedKey)]="selectedPeriod">
        </custom-select>
    </fieldset>

    <fieldset>
        <label for="debtorType" class="label">
            {{'Reports.Filters.DebtorType' | translate}}
        </label>
        <custom-select name="debtorType" [options]="debtorTypeOptions" [(selectedKey)]="selectedDebtorType">
        </custom-select>
    </fieldset>

    <label class="custom-checkbox-container">
        <input type="checkbox" class="column-checkbox" [(ngModel)]="includeReminderCases" name="includeReminderCases"
            id="includeReminderCases">
        <span class="checkmark"></span>
        <label for="includeReminderCases">{{'Reports.SuccessRate.IncludeReminderCases' | translate}}</label>
    </label>

    <button class="button-basic" (click)="onGenerateReport()">
        {{'Reports.Buttons.GenerateReport' | translate}}
    </button>
</section>

<section class="results-container" *ngIf="showResults">
    <iframe *ngIf="renderedReport" [src]="renderedReport" frameBorder="0" width="100%" height="750"></iframe>
</section>